<script lang="ts">
	//UI
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import ActionWithCollections from "../component/FAQ/ActionWithCollections.svelte";
	import AreYouSure from "@hitit/hub/src/v7/components/common/AreYouSure.svelte";
	import Items from "../component/FAQ/Items.svelte";
	import DetailViewer from "../component/FAQ/DetailViewer.svelte";
	import CollectionHead from "../component/FAQ/CollectionHead.svelte";
	import SetupCollection from "../component/FAQ/SetupCollection.svelte";
	import SingleEditor, {
		type SaveDetail,
	} from "../component/FAQ/SingleEditor.svelte";
	//Utils
	import { api, notifications } from "@hitit/hub/src/stores";
	import { popup } from "@hitit/hub/src/v7/store";
	import {
		FAQ,
		FAQ_Category,
		FAQ_Manager,
	} from "@hitit/mbr/src/v7/class/FAQ/FAQ_Manager";
	import { GoBackButton } from "@hitit/new_ui";
	//Types
	//Props

	//Constants
	//PopupHandler

	const categoryDeletePopupHandler = (e: { detail: FAQ_Category }) => {
		$popup = {
			component: AreYouSure,
			props: {
				textTranslation: "mbr.faq.delete_category",
				accept: () => deleteCategory(e.detail),
				cancel: () => ($popup = undefined),
			},
		};
	};

	const itemDeletePopupHandler = (e: { detail: string }) => {
		$popup = {
			component: AreYouSure,
			props: {
				textTranslation: "mbr.faq.delete_qna",
				accept: () => deleteFAQ(e.detail),
				cancel: () => ($popup = undefined),
			},
		};
	};

	//Variables
	let editmode = false;
	let loading = false;
	let selectedItem: FAQ | null = null;

	let selectedCategoryName = "전체";
	let faqManager: FAQ_Manager;
	let setupCategory: FAQ_Category | null = null;

	$: mobileDisplayCondition = selectedItem !== null;
	$: selectedCategory = faqManager
		? faqManager.getCategories().find((v) => v.name === selectedCategoryName)
		: null;
	//Functions
	async function modeHandler() {
		let total = 0;
		let present = 0;
		let phase = "";
		try {
			if (editmode === false) return (editmode = true);
			const {
				newFaqs,
				updatedFaqs,
				onlyCategoryUpdatedFaqs,
				indexChangedFaqs,
				deletedFaqs,
			} = faqManager.getDTO_ToSend();
			loading = true;
			total =
				newFaqs.length +
				updatedFaqs.length +
				onlyCategoryUpdatedFaqs.length +
				deletedFaqs.length;
			//

			if (indexChangedFaqs.length) {
				console.log("INDEXED_CHANGE");
				phase = `상태 : 순서변경 <br/>,id:[${indexChangedFaqs
					.map((v) => v.id)
					.join(",")}]`;
				await $api.updateFAQ_Displaysort(
					indexChangedFaqs.map((v) => ({
						id: v.id as string,
						newDisplaySort: v.displaySort,
					}))
				);
			}

			if (onlyCategoryUpdatedFaqs.length) {
				console.log("Only Category Update");

				const map: { [key: string]: string[] } = {};
				for (const faq of onlyCategoryUpdatedFaqs) {
					const category = faq.category;
					if (typeof map[category] === "undefined")
						map[category] = [faq.id as string];
					else map[category].push(faq.id as string);
				}

				for (const [category, uuids] of Object.entries(map)) {
					phase = `상태 : 오직 카테고리만 변경 <br/>,id:[${uuids.join(",")}]`;
					await $api.updateFAQ_Category(category, uuids);
					present += uuids.length;
				}
			}

			// Updated without Category
			for (const dto of updatedFaqs) {
				console.log("Update", dto);
				phase = `상태 : 수정 <br/>,id:[${dto.id}]`;
				await $api.updateFAQ_Document(dto.id || "", dto);
				present++;
			}
			// Delete
			for (const dto of deletedFaqs) {
				console.log("Delete", dto);
				phase = `상태 : 삭제 <br/>,id:[${dto.id}]`;
				await $api.deleteFAQ_Document(dto.id || "");
				present++;
			}
			// Created
			for (const dto of newFaqs) {
				console.log("Create", dto);
				phase = `상태 : 생성 <br/>,question:[${dto.question}]`;
				await $api.createFAQ_Document(dto);
				present++;
			}

			init();
		} catch (error) {
			notifications.append(
				"ERROR",
				`실패<br/>${phase}`,
				"",
				undefined,
				"WARNING"
			);

			console.log(error);
		} finally {
			loading = false;
		}
	}

	async function itemClickHandler(e: { detail: string }) {
		try {
			const id = e.detail;
			const originItem = selectedCategory!.getFAQ_ById(id) as FAQ;

			loading = true;

			if (originItem.answer === undefined) {
				const { data } = await $api.getFAQ_Document(id);
				originItem.answer = data.faqDTO.answer;
			}
			selectedItem = originItem;
		} catch (error) {
			alert("데이터를 불러오지 못 했습니다.");
		} finally {
			loading = false;
		}
	}

	function deleteFAQ(id: string) {
		faqManager.deleteQnA_ById(id);
		faqManager = faqManager;
		selectedItem =
			selectedItem !== null && selectedItem.id === id ? null : selectedItem;
		$popup = undefined;
	}

	function newItemHandler() {
		const newItemDisplaysort = faqManager.getNewItemDisplaySort();
		const newItem = FAQ.convenienceConstructor(
			newItemDisplaysort,
			"DRAFT",
			selectedCategoryName
		);
		newItem.answer = "<p></p>";
		selectedItem = newItem;
	}

	function collectionClickHandler(e: { detail: string }) {
		selectedCategoryName = e.detail;
		selectedItem = null;
	}

	function newCollectionHandler(e: { detail: string }) {
		faqManager.addCategory(e.detail);
		faqManager = faqManager;
	}
	// SetupCategory
	function setupCategoryHandler(e: { detail: FAQ_Category }) {
		setupCategory = setupCategory === null ? e.detail : null;
	}

	function updateCategoryName(e: { detail: string }) {
		if (selectedItem) selectedItem.category = e.detail;
		setupCategory?.updateName(e.detail);
		faqManager.resoting();
		selectedCategoryName = e.detail;
		faqManager = faqManager;
	}

	function deleteCategory(category: FAQ_Category) {
		faqManager.deleteCategory(category);
		faqManager.resoting();
		faqManager = faqManager;
		selectedItem = null;
		$popup = undefined;
	}
	function updateDisplaySortHandler(e: {
		detail: { oldIndex: number; newIndex: number };
	}) {
		const { oldIndex, newIndex } = e.detail;
		if (oldIndex === newIndex) return;

		const from = selectedCategory!.faqs.find((v, i) => i === oldIndex) as FAQ;
		const to = selectedCategory!.faqs.find((v, i) => i === newIndex) as FAQ;

		faqManager.updateDisplaySort(from, to);
		selectedCategory = selectedCategory;
		faqManager = faqManager;
		selectedItem = selectedItem;
	}

	// Save
	function saveHandler(e: { detail: SaveDetail }) {
		const { question, answer, documentState, origin } = e.detail;
		const reg = FAQ_Manager.tempREG;
		origin.answer = answer;
		origin.question = question;
		origin.documentState = documentState;
		if (reg.test(origin.id || "")) {
			faqManager.addNewItem(origin);
		} else {
			faqManager.updateItemArticle(origin);
		}

		faqManager = faqManager;
		selectedItem = null;
	}

	async function init(retryCount = 3) {
		try {
			loading = true;
			// await
			const { data } = await $api.getFAQ_DocumentList();
			faqManager = new FAQ_Manager(data.faqListDTOList);
			selectedCategoryName = "전체";
			editmode = false;
			loading = false;
		} catch (error) {
			if (retryCount === 0) return;

			init(retryCount - 1);
		}
	}
	//Do
	$: init();
</script>

{#if loading}
	<ContainerLoading />
{/if}
{#if faqManager}
	<div class="container">
		<div class="action-box">
			<ActionWithCollections
				on:COLLECTION_CLICK={collectionClickHandler}
				on:CREATE_NEW_COLLECTION={newCollectionHandler}
				selectedName={selectedCategoryName}
				editmode={editmode}
				actionHandler={modeHandler}
				collections={faqManager.getCategories()}
			/>
		</div>
		<div class="items-detail">
			<div class="items-box">
				{#if selectedCategory}
					<CollectionHead
						on:SETUP_CATEGORY_REQUEST={setupCategoryHandler}
						hasSetup={setupCategory !== null}
						category={selectedCategory}
						editable={selectedCategory.editable}
						editmode={editmode}
					>
						<div slot="setup">
							{#if setupCategory !== null}
								<SetupCollection
									on:UPDATE_CATEGORY={updateCategoryName}
									on:DELETE_CATEGORY={categoryDeletePopupHandler}
									existCategoryNames={faqManager.getNames()}
									clickOutsideCallBack={() => (setupCategory = null)}
									category={setupCategory}
								/>
							{/if}
						</div>
					</CollectionHead>
					<Items
						addButtonHide={selectedCategoryName === FAQ_Manager.__All__}
						items={selectedCategory.mappingItems()}
						editmode={editmode}
						on:UPDATED_ITEM_DISPLAY_SORT
						on:ITEM_CLICK={itemClickHandler}
						on:ITEM_DELETE={itemDeletePopupHandler}
						on:UPDATED_ITEM_DISPLAY_SORT={updateDisplaySortHandler}
						on:NEW_ITEM={newItemHandler}
					/>
				{/if}
			</div>
			<div
				class="detail-box"
				class:mobileDisplayCondition={mobileDisplayCondition}
			>
				<div class="goBack">
					<GoBackButton
						on:click={() => {
							selectedItem = null;
						}}
					/>
				</div>
				{#if !editmode && selectedItem !== null}
					<DetailViewer item={selectedItem} />
				{:else if editmode && selectedItem !== null}
					<SingleEditor item={selectedItem} on:SAVE={saveHandler} />
				{/if}
			</div>
		</div>
	</div>
{/if}

<style lang="scss">
	@import "../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;
		.action-box {
			display: flex;
			flex-direction: row-reverse;
		}

		.items-detail {
			display: flex;
			width: 100%;
			.items-box {
				width: 100%;
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
		}
		.detail-box {
			display: none;
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			overflow-y: auto;
			background-color: #f0f0f4;
			padding: 70px 20px 20px 20px;
			box-sizing: border-box;
			&.mobileDisplayCondition {
				display: flex;
				flex-direction: column;
			}
			.goBack {
				width: 30px;
				height: 27px;
				position: absolute;
				top: 23.2px;
				right: 20px;
			}
		}
	}
	@include DesktopSize {
		.container {
			.items-detail {
				height: 800px;
				gap: 20px;
				.items-box {
					flex-basis: 950px;
					flex-grow: 1;
					min-width: 0;
					gap: 20px;
				}
				.detail-box {
					min-width: 500px;
					flex-basis: 622px;
					max-width: 622px;
					flex-grow: 1;
				}
			}

			.detail-box {
				padding: 0;
				display: flex;
				flex-direction: column;
				position: static;
				min-height: 0;
				max-height: none;
				flex-basis: calc(100% * (642 / 1594));
				max-width: 642px;
				/* temp debuging point */
				.goBack {
					display: none;
				}
			}
		}
	}
</style>
